// Consentement CGU/CGV AVANT un bouton OAuth (#2378).
//
// Le flux Google WEB quitte la page (redirection vers accounts.google.com) puis
// revient sur /auth/google/callback dans un montage React neuf : seul le
// sessionStorage survit à l'aller-retour (même mécanique que `gively_return_to`).
// On y dépose l'intention cochée au clic, on la relit UNE fois au retour, et on
// l'envoie au serveur dans le POST d'échange (`accept_terms`). C'est le serveur
// qui journalise l'acte ; ce module ne prouve rien par lui-même, il TRANSPORTE.
export const CLE_CONSENTEMENT_OAUTH = "gively_oauth_terms";

export const memoriserConsentementOauth = (accepte) => {
  try { sessionStorage.setItem(CLE_CONSENTEMENT_OAUTH, accepte ? "1" : "0"); } catch (_) { /* navigation privée */ }
};

/** Lit ET efface : une intention ne sert qu'à un seul échange. */
export const lireConsentementOauth = () => {
  try {
    const v = sessionStorage.getItem(CLE_CONSENTEMENT_OAUTH) === "1";
    sessionStorage.removeItem(CLE_CONSENTEMENT_OAUTH);
    return v;
  } catch (_) {
    return false;
  }
};
